import axios from 'axios';
import Bluebird from 'bluebird';
import path from 'path';
import fs from 'fs';

import AxiosError from './AxiosError';
import { buildEncodedFormData } from './formUtils'
import root from 'window-or-global'

export default class ApiCore {

    constructor(apiConfig, authToken) {
        this.apiConfig = apiConfig;
        this.authToken = authToken;
        this._AXIOS = generateAxiosInstance(apiConfig, authToken);
    }

    delete(urlPath) {
        return this._AXIOS.delete(urlPath)
            .then(resp => resp.data)
            .catch(cleanErrors);
    }

    get(urlPath, params) {
        return this._AXIOS.get(urlPath, { params })
            .then(resp => resp.data)
            .catch(cleanErrors);
    }

    getXML(urlPath, params) {
        const axiosXml = generateAxiosInstance(this.apiConfig, this.authToken, true);

        return axiosXml.get(urlPath, { params })
            .then(res => res.data)
            .catch(cleanErrors);
    }

    postFormData(path, formData) {
        const encodedFormData = buildEncodedFormData(formData);
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
        };
        // console.log('postFormData.path:', path, encodedFormData, axiosConfig);
        return this._AXIOS.post(path, encodedFormData, axiosConfig)
            .then(resp => resp.data)
            .catch(cleanErrors)
    }

    put(urlPath, data) {
        return this._AXIOS.put(urlPath, data)
            .then(resp => resp.data)
            .catch(cleanErrors);
    }

    setAuthToken(authToken) {
        this.authToken = authToken;
        this._AXIOS = generateAxiosInstance(this.apiConfig, this.authToken);
    }

    updateApiServer(apiServer) {
        console.log('UPDATING API SERVER FROM: %s to %s',this.apiConfig.apiServer, apiServer);
        this.apiConfig.apiServer = apiServer;
        this._AXIOS = generateAxiosInstance(this.apiConfig, this.authToken);
    }

}



function generateAxiosInstance(apiConfig, authToken, isXml) {
    let axiosConfig = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        baseURL: apiConfig.apiServer,
        timeout: apiConfig.timeoutInMs || 15000,
    };

    if (isXml) {
        axiosConfig.headers = {
            'Content-Type': 'application/xml',
        };
    }
    if (apiConfig.mode) {
        axiosConfig.mode = apiConfig.mode;
    }
    if (apiConfig.publicApiKey) {
        axiosConfig.headers['Ocp-Apim-Subscription-Key'] = apiConfig.publicApiKey;
    }
    if (authToken) {
        axiosConfig.headers.Authorization = 'Bearer ' + authToken;
    }
    if(apiConfig.debug){
    console.log('generateAxiosInstance axiosConfig:\n', axiosConfig);
    }
    return axios.create(axiosConfig);
}




function cleanErrors(error) {
    // console.log('CLEAN ERRORS');
    // console.log('axiosError', error);
    // console.log('axiosError.message', error.message);
    // console.log('axiosError.config', error.config);
    if (error.config) {
        throw new AxiosError(error);
    }
    throw error;
}



// WEBPACK FOOTER //
// ./src/Utils/ApiCore.js


// WEBPACK FOOTER //
// webpack:///src/Utils/ApiCore.js